define(
    'viewmodels/secured/lists/delete',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, dataProvider, i19n) {
        var vm = new ViewModel(
        {
            i19n: i19n,
            id: '',
            name: '',
            notify: {},
            reload: {},
            comboClick: {}
        });

        vm.activate = function () {
            var self = this;
        };
        vm.attached = function () {
            var self = this;
        };
        vm.deleteClick = function () {
            var self = this;

            dataProvider.
                lists
                .deleteList(self.id)
                .done(function (result) {
                    self.notify('success', i19n.to.listdeleted);
                    self.reload();
                    self.comboClick();
                })
                .fail(function (result) {
                    self.notify(result.error);
                });

        };
        vm.cancelClick = function () {
            var self = this;

            self.comboClick(self.id);
        };

        return vm;
    }
);
